import { useState } from "react";
import { supabase } from "../lib/supabase";
import { toast } from "react-hot-toast"; // Using react-hot-toast for notifications

export default function Login() {
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [errorMsg, setErrorMsg] = useState("");
	const [loading, setLoading] = useState(false);

	async function handleLogin(e) {
		e.preventDefault();
		setLoading(true);

		try {
			// Sign in using Supabase Auth
			const { data: userResponse, error: loginError } =
				await supabase.auth.signInWithPassword({
					email,
					password,
				});

			console.log("Login response:", { userResponse, loginError }); // Log the response for debugging

			if (loginError) {
				setErrorMsg("Authentication failed: " + loginError.message);
				setLoading(false);
				return;
			}

			// Access user and session from the response object
			const user = userResponse?.user;
			const session = userResponse?.session;

			if (!user || !user.id) {
				setErrorMsg("User authentication failed. Please try again.");
				setLoading(false);
				return;
			}

			// Now check if the user is confirmed (email verification)
			if (!session || !user.email_confirmed_at) {
				setErrorMsg("Please verify your email before logging in.");
				setLoading(false);
				return;
			}

			// Check if the user's profile exists
			const { error: profileError } = await supabase
				.from("profiles")
				.select("role")
				.eq("id", user.id)
				.single();

			if (profileError) {
				// If profile doesn't exist, create one
				const { error: insertProfileError } = await supabase
					.from("profiles")
					.insert([
						{
							id: user.id,
							email: user.email,
							role: "user", // Default to 'user' role
						},
					]);

				if (insertProfileError) {
					setErrorMsg(
						"Error creating profile: " + insertProfileError.message
					);
					setLoading(false);
					return;
				}
			}

			// Successful login
			toast.success("Login successful!");
			window.location.href = "/gear"; // Or use `navigate("/gear")` if you're using react-router
		} catch (err) {
			setErrorMsg("An error occurred while logging in.");
			setLoading(false);
			console.error(err);
		}
	}

	return (
		<div className="main">
			<div className="loginBox">
				<h2>Login</h2>
				{errorMsg && <p style={{ color: "red" }}>{errorMsg}</p>}
				<form onSubmit={handleLogin}>
					<input
						type="email"
						placeholder="Email"
						value={email}
						onChange={(e) => setEmail(e.target.value)}
						required
					/>
					<br />
					<input
						type="password"
						placeholder="Password"
						value={password}
						onChange={(e) => setPassword(e.target.value)}
						required
					/>
					<br />
					<button type="submit" disabled={loading}>
						{loading ? "Logging in..." : "Login"}
					</button>
				</form>
			</div>
		</div>
	);
}
